import { Stack, type StackProps } from 'tamagui'

export default function CobuStack({ layout = 'vertical', ...props }: StackProps & { layout?: 'vertical' | 'horizontal' }) {
  return <Stack flexDirection={layout === 'horizontal' ? 'row' : 'column'} {...props} />
}
